export default "__VITE_ASSET__BRp5uv8f__"